import Vue from 'vue'
import App from './App'
import router from './router'

var events = require("events");
Vue.prototype.eventEmitter = new events.EventEmitter();

import { Button, Field, Checkbox, Toast, Dialog } from 'vant';

import action from './http/index'
import message from "./common/message"

Vue.use(Button);
Vue.use(Field);
Vue.use(Checkbox);
Vue.use(Toast);
Vue.use(Dialog);

Vue.config.productionTip = false
Vue.prototype.action = action
Vue.prototype.message = message;
Vue.config.errorHandler = function (err, vm, info) {
  console.log("全局捕获异常：" + err.stack.toString())
  //上报给服务端
  action.requestLog({
    log_type: "error",
    content: err.stack.toString(),
  })
}

//添加消息监听
window.addEventListener("message", message.receMessage, false);

var whiteList = ['/', '/init', '/error']
router.beforeEach(async (to, from, next) => {
  var params = window.TXPARAMS
  if (whiteList.indexOf(to.path) !== -1) {
    next()
  } else {
    if (params && params.ad_position_id && params.package_id) {
      next()
    } else {
      next({ path: '/error', query: { msg: encodeURI('初始化异常') } })
    }
  }
})

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  created: function () {
    window.router = this.$router;
    window.action = this.action
    window.eventEmitter = this.eventEmitter;
    window.toast = this.$toast;
    window.TXMessage = this.message;
  },
  mounted() { }
})

window.NativeRealName = function (params, id, token, info = {}) {
  window.TXPARAMS = params
  window.TXID = id
  window.TXTOKEN = token
  if ((params.ad_position_id == 10050070 && params.package_id == 42191) || (params.ad_position_id == 10035855 && params.package_id == 30610)) {
    window.postMessage({ msg_type: 'itx_native_realname2' }, '*')
  } else {
    window.postMessage({ msg_type: 'itx_native_realname', data: info }, '*')
  }
}



// WEBPACK FOOTER //
// ./src/main.js